(() => {
  const initStickyAtc = () => {
    const bar = document.querySelector('[data-ps-sticky-atc]');
    const original = document.querySelector('.template-product [data-product-form-regular] [data-product-atc]');
    if (!bar || !original || bar.dataset.psInit === 'true') return;
    bar.dataset.psInit = 'true';
    bar.hidden = false;
    const stickyButton = bar.querySelector('[data-ps-sticky-button]');
    const stickyPrice = bar.querySelector('[data-ps-sticky-price]');
    const pricing = document.querySelector('.template-product [data-product-pricing]');

    const sync = () => {
      if (stickyButton) {
        stickyButton.disabled = !!original.disabled;
        const label = original.querySelector('.atc-button--text');
        if (label && label.textContent.trim()) stickyButton.textContent = label.textContent.trim();
      }
      if (stickyPrice && pricing) {
        const current = pricing.querySelector('.price__current');
        if (current && current.textContent.trim()) stickyPrice.textContent = current.textContent.replace(/\s+/g, ' ').trim();
      }
    };

    const updateVisibility = () => {
      const rect = original.getBoundingClientRect();
      const show = rect.bottom < 0 && !original.closest('[hidden]');
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('ps-sticky-atc-active', show && window.matchMedia('(max-width: 719px)').matches);
    };

    stickyButton?.addEventListener('click', () => {
      sync();
      if (!original.disabled) original.click();
    });
    document.addEventListener('change', (e) => {
      if (e.target.closest && e.target.closest('[data-product-form]')) requestAnimationFrame(sync);
    });
    if (pricing) new MutationObserver(sync).observe(pricing, {subtree:true, childList:true, characterData:true, attributes:true});
    new MutationObserver(sync).observe(original, {subtree:true, childList:true, characterData:true, attributes:true});
    window.addEventListener('scroll', updateVisibility, {passive:true});
    window.addEventListener('resize', updateVisibility, {passive:true});
    sync(); updateVisibility();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initStickyAtc);
  else initStickyAtc();
  document.addEventListener('shopify:section:load', initStickyAtc);
})();
